import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';

import { TerminalContextConstants } from '@sdbn/tmc-common';
import { CheckCabotageAPIService } from '../../api/transportmanagement/CheckCabotage.service';
import { TransportCabotageCheck } from '../../api/transportmanagement/transportmanagement.model';

export class TransportRegistrationCabotageController extends AbstractStepController {

  checkCabotageAPIService: CheckCabotageAPIService

  constructor(
  ) {
    super();
    this.checkCabotageAPIService = WizardServiceLocator.injector!.get(CheckCabotageAPIService);
  }

  onContextChange(contextChange: ContextChange) {

  }

  onRegisterToDashboardContext() {

  }

  public handleFlow(): FlowStepHandleResult {

    if (this.dashboardContext.getContextValue(TerminalContextConstants.registrationId) == null) {
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.NEXT;
      return result;
    }

    const cabotageCheck = new TransportCabotageCheck({
      transportId: this.dashboardContext.getContextValue(TerminalContextConstants.registrationId),
      numberPlate: this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate)
    });
    this.checkCabotageAPIService.execute(cabotageCheck).subscribe(result => {
      if (result) {
        this.wizardComponent.next();
      } else {
        this.wizardComponent.handoverToFlow('cabotage-failed');
      }
    });

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.PROCESSING;
    return result;

  }

  getControls(): StepControl[] {

    return new Array<StepControl>();
  }
}
